export default "__VITE_ASSET__DmJDH_Pn__"